<script>
    import { fly } from 'svelte/transition'
    import { push } from "svelte-spa-router";
    import { Cell, CellGroup } from "../index";
    //
    const menus = [
        {
            title: "通用",
            items: [
                {
                    title: "Button 按钮",
                    id: "ButtonCpts",
                },
                {
                    title: "Icon 图标",
                    id: "IconCpts",
                },
            ],
        },
        {
            title: "布局",
            items: [
                {
                    title: "AutoCenter 自动居中",
                    id: "AutoCenterCpts",
                },
                {
                    title: "Divider 分割线",
                    id: "DividerCpts",
                },
                {
                    title: "Grid 栅格",
                    id: "GridCpts",
                },
                {
                    title: "SafeArea 安全区",
                    id: "SafeAreaCpts",
                },
                {
                    title: "Space 间距",
                    id: "SpaceCpts",
                },
            ],
        },
        {
            title: "导航",
            items: [
                {
                    title: "CapsuleTabs 胶囊选项卡",
                    id: "CapsuleTabsCpts",
                },
                {
                    title: "IndexBar 序列",
                    id: "IndexBarCpts",
                },
                {
                    title: "JumboTabs 复杂选项卡",
                    id: "JumboTabsCpts",
                },
                {
                    title: "NavBar 导航栏",
                    id: "NavBarCpts",
                },
                {
                    title: "SideBar 侧边导航",
                    id: "SideBarCpts",
                },
                {
                    title: "TabBar 标签栏",
                    id: "TabBarCpts",
                },
                {
                    title: "Tabs 标签页",
                    id: "TabsCpts",
                },
            ],
        },
        {
            title: "信息展示",
            items: [
                {
                    title: "Avatar 头像",
                    id: "AvatarCpts",
                },
                {
                    title: "Card 卡片",
                    id: "CardCpts",
                },
                {
                    title: "Accordion 折叠面板",
                    id: "AccordionCpts",
                },
                {
                    title: "Ellipsis 文本省略",
                    id: "EllipsisCpts",
                },
                {
                    title: "FloatingPanel 浮动面板",
                    id: "FloatingPanelCpts",
                },
                {
                    title: "Image 图片",
                    id: "ImageCpts",
                },
                {
                    title: "ImageViewer 图片查看器",
                    id: "ImageViewerCpts",
                },
                {
                    title: "InfiniteScroll 无限滚动",
                    id: "InfiniteScrollCpts",
                },
                {
                    title: "Cell 单元格",
                    id: "CellCpts",
                },
                {
                    title: "PageIndicator 页码指示器",
                    id: "PageIndicatorCpts",
                },
                {
                    title: "Steps 步骤条",
                    id: "StepsCpts",
                },
                {
                    title: "Carousel 走马灯",
                    id: "CarouselCpts",
                },
                {
                    title: "Swiper 走马灯",
                    id: "SwiperCpts",
                },
                {
                    title: "Tag 标签",
                    id: "TagCpts",
                },
                {
                    title: "WaterMark 水印",
                    id: "WaterMarkCpts",
                },
            ],
        },
        {
            title: "信息录入",
            items: [
                {
                    title: "Cascader 级联选择",
                    id: "CascaderCpts",
                },
                {
                    title: "CascaderView 级联选择视图",
                    id: "CascaderViewCpts",
                },
                {
                    title: "CheckList 可勾选列表",
                    id: "CheckListCpts",
                },
                {
                    title: "Checkbox 复选框",
                    id: "CheckboxCpts",
                },
                {
                    title: "Form 表单",
                    id: "FormCpts",
                },
                {
                    title: "Input 输入框",
                    id: "InputCpts",
                },
                {
                    title: "Picker 选择器",
                    id: "PickerCpts",
                },
                {
                    title: "PickerView 选择器视图",
                    id: "PickerViewCpts",
                },
                {
                    title: "Radio 单选框",
                    id: "RadioCpts",
                },
                {
                    title: "Rate 评分",
                    id: "RateCpts",
                },
                {
                    title: "SearchBar 搜索框",
                    id: "SearchBarCpts",
                },
                {
                    title: "Selector 选择组",
                    id: "SelectorCpts",
                },
                {
                    title: "Slider 滑动输入条",
                    id: "SliderCpts",
                },
                {
                    title: "InputNumber 步进器",
                    id: "InputNumberCpts",
                },
                {
                    title: "Switch 开关",
                    id: "SwitchCpts",
                },
                {
                    title: "TextArea 文本域",
                    id: "TextAreaCpts",
                },
            ],
        },
        {
            title: "反馈",
            items: [
                {
                    title: "ActionSheet 动作面板",
                    id: "ActionSheetCpts",
                },
                {
                    title: "Dialog 对话框",
                    id: "DialogCpts",
                },
                {
                    title: "Empty 空状态",
                    id: "EmptyCpts",
                },
                {
                    title: "ErrorBlock 异常",
                    id: "ErrorBlockCpts",
                },
                {
                    title: "Loading 加载中",
                    id: "LoadingCpts",
                },
                {
                    title: "Mask 遮罩层",
                    id: "MaskCpts",
                },
                {
                    title: "Modal 弹窗",
                    id: "ModalCpts",
                },
                {
                    title: "Popover 气泡弹出框",
                    id: "PopoverCpts",
                },
                {
                    title: "Popup 弹出层",
                    id: "PopupCpts",
                },
                {
                    title: "ProgressBar 进度条",
                    id: "ProgressBarCpts",
                },
                {
                    title: "ProgressCircle 进度圈",
                    id: "ProgressCircleCpts",
                },
                {
                    title: "PullToRefresh 下拉刷新",
                    id: "PullToRefreshCpts",
                },
                {
                    title: "Result 结果",
                    id: "ResultPageCpts",
                },
                {
                    title: "Skeleton 骨架屏",
                    id: "SkeletonCpts",
                },
                {
                    title: "SwipeAction 滑动操作",
                    id: "SwipeActionCpts",
                },
                {
                    title: "Toast 轻提示",
                    id: "ToastCpts",
                },
            ],
        },
        {
            title: "引导提示",
            items: [
                {
                    title: "Badge 徽标",
                    id: "BadgeCpts",
                },
                {
                    title: "NoticeBar 通告栏",
                    id: "NoticeBarCpts",
                },
            ],
        },
        {
            title: "其他",
            items: [
                {
                    title: "ConfigProvider 配置",
                    id: "ConfigProviderCpts",
                },
            ],
        },
        {
            title: "试验性",
            items: [
                {
                    title: "Calendar 日历",
                    id: "CalendarCpts",
                },
                {
                    title: "Dropdown 下拉菜单",
                    id: "DropdownCpts",
                },
                {
                    title: "FloatingBubble 浮动气泡",
                    id: "FloatingBubbleCpts",
                },
                {
                    title: "ImageUploader 图片上传",
                    id: "ImageUploaderCpts",
                },
                {
                    title: "Keyboard 虚拟键盘",
                    id: "KeyboardCpts",
                },
                {
                    title: "PasscodeInput 密码输入框",
                    id: "PasscodeInputCpts",
                },
                {
                    title: "ResultPage 结果页面",
                    id: "ResultPageCpts",
                },
                {
                    title: "TreeSelect 级联选择器",
                    id: "TreeSelectCpts",
                },
                {
                    title: "VirtualInput 虚拟输入框",
                    id: "VirtualInputCpts",
                },
                {
                    title: "PdfViewer pdf阅读器",
                    id: "PdfViewerCpts",
                },
            ],
        },
    ];

    //
    function navigatorTo(data) {
        const { title, id } = data;
        push(`/components/${id}`);
    }
</script>

<div class="menu" transition:fly={{x:-200}}>
    {#each menus as { items, title }, i}
        <CellGroup {title}>
            {#each items as cell}
                <Cell title={cell.title} on:click={() => navigatorTo(cell)} />
            {/each}
        </CellGroup>
    {/each}
</div>

<style lang="less">
    .menu {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
    }
</style>
